import React from 'react';
import './HomePage.css';
// Add this import at the top
import logo from '../Assets/Hifilogic-Logo-Fullsize.png';

const HomePage = () => {
  return (
    <div className="home-container">
      {/* Header */}
      <header className="header">
        <div className="logo">
          <img src={logo} alt="HifiLogic Logo" className="logo-img" />
          
        </div>
        <nav>
          <ul>
            <li><a href="#services">Services</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
      </header>

      {/* Banner */}
      <section className="banner" id="home">
        <div className="banner-content">
          <h1>IT Consulting & Digital Solutions</h1>
          <p>Enterprise Solutions | Digital Transformation | Technology Innovation</p>
        </div>
      </section>

      {/* Services Section */}
      <section className="services" id="services">
        <h2>Our Services</h2>
        <div className="services-container">
          <div className="service-box">
            <h3>Enterprise Solutions</h3>
            <ul>
              <li>ETRM Solutions</li>
              <li>Legacy AS/400 solutions</li>
              <li>Custom Applications</li>
              <li>System Integration</li>
            </ul>
          </div>
          <div className="service-box">
            <h3>Digital Transformation</h3>
            <ul>
              <li>Strategy Development</li>
              <li>Process Automation</li>
              <li>Cloud Migration</li>
              <li>Digital Workflows</li>
            </ul>
          </div>
          <div className="service-box">
            <h3>AI Solutions</h3>
            <ul>
              <li>Leveraging AI Potential</li>
              <li>Predictive analysis</li>
              <li>Automate using AI tools</li>
              <li>Custom Python based solutions</li>
            </ul>
          </div>
          <div className="service-box">
            <h3>IT Consulting</h3>
            <ul>
              <li>Technology Assessment</li>
              <li>IT Strategy</li>
              <li>Project Management</li>
              <li>Business Analysis</li>
            </ul>
          </div>
          <div className="service-box">
            <h3>Offshore support</h3>
            <ul>
              <li>Call center</li>
              <li>Nightly Applicaiton Support</li>
              <li>Business Process Outsorcing</li>
            </ul>
          </div>
          <div className="service-box">
            <h3>Real Estates Solution</h3>
            <ul>
              <li>Dedicated team for Real estate needs</li>
              <li>Property Management</li>
              <li>Loan processing solution</li>
            </ul>
          </div>
          <div className="service-box">
            <h3>Hotel Management Solution</h3>
            <ul>
              <li>Booking Engine</li>
              <li>OTA interfacing</li>
              <li>Website for your Hotel business</li>
            </ul>
          </div>
          <div className="service-box">
            <h3>Cyber Security</h3>
            <ul>
              <li>Incident Response</li>
              <li>Cybersecurity Assesment</li>
            </ul>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about" id="about">
        <div className="about-content">
          <div className="about-text">
            <h2>About Us</h2>
            <p>HifiLogic is a leading IT consulting firm specializing in enterprise solutions and digital transformation. With over 15 years of experience, we help businesses leverage technology to achieve their strategic goals.</p>
          </div>
          <div className="expertise">
            <h3>Core Expertise</h3>
            <div className="expertise-grid">
              <span>IT Service Management</span>
              <span>Enterprise Architecture</span>
              <span>Business Process Optimization</span>
              <span>Cloud Solutions</span>
              <span>Digital Strategy</span>
              <span>System Integration</span>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact" id="contact">
        <h2>Contact Us</h2>
        <div className="contact-container">
          <div className="contact-info">
            <h3>Get in Touch</h3>
            <p>Greater Houston Area</p>
            <p>Email: admin@hifilogicconsulting.com</p>
            <div className="social-links">
              <a href="https://www.linkedin.com/in/arulanandham-ruthirapathi-2226195/" 
                 target="_blank" 
                 rel="noopener noreferrer">
                LinkedIn
              </a>
            </div>
          </div>
          <div className="contact-form">
            <h3>Send us a Message</h3>
            <form>
              <input type="text" placeholder="Name" />
              <input type="email" placeholder="Email" />
              <textarea placeholder="Message"></textarea>
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <p>&copy; 2024 HifiLogic. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;